module.exports = __webpack_public_path__ + "static/media/calendar_icon.8a432648.png";